import MetricBar from "./MetricBar";
import InfoHelp from "./InfoHelp";

function toTestId(label) {
  return String(label || "metric").trim().toLowerCase().replace(/[^a-z0-9]+/g, "-");
}

// `valueParts={{ primary, secondary }}` is the alternative to `value`: the
// primary part takes the action tone, the secondary part stays neutral.
// `barSegments` switches the bar to segments; `showBar={false}` omits it.
export default function MetricTile({
  label,
  value,
  valueParts,
  note,
  barValue = 0,
  barMax = 100,
  barSegments,
  showBar = true,
  helpTitle,
  helpBody,
}) {
  return (
    <div className="lz-product-metric-tile" data-testid={`metric-${toTestId(label)}`}>
      <span className="lz-product-metric-tile__value">
        {valueParts ? (
          <>
            <span className="lz-product-metric-tile__value-primary">{valueParts.primary}</span>
            <span className="lz-product-metric-tile__value-secondary">{valueParts.secondary}</span>
          </>
        ) : (
          value
        )}
      </span>
      <span className="lz-product-metric-tile__label">
        {label}
        {helpTitle && helpBody ? (
          <InfoHelp label={label} title={helpTitle}>{helpBody}</InfoHelp>
        ) : null}
      </span>
      {showBar ? (
        <MetricBar value={barValue} max={barMax} label={label} segments={barSegments} />
      ) : null}
      {note != null && note !== false ? (
        <span className="lz-product-metric-tile__note">{note}</span>
      ) : null}
    </div>
  );
}
